module.exports = __webpack_public_path__ + "fb9a09f6698cca434bc6e6394282743c.png";